import React, { useState, useEffect } from "react";
import { fetchThreads } from "./api/threadapi";
import "./App.css";
import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import Thread from "./components/Thread";
import Home from "./components/Home";

function App() {
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [showThread, setShowThread] = useState(false);
  const [currentPage, setCurrentPage] = useState("Home");
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [usernamePopup, setUsernamePopup] = useState(false);

  const [username, setUsername] = useState();

  useEffect(() => {
    const getThreads = async () => {
      if (!selectedTrack) return;
      setLoading(true);
      setError(null);

      try {
        const response = await fetchThreads(selectedTrack);
        // Backend returns { threads: [...] }

        setThreads(response.threads || []);
      } catch (error) {
        setError("Error fetching threads");
        console.error("Error fetching threads:", error);
      } finally {
        setLoading(false);
      }
    };

    getThreads();
  }, [selectedTrack]);

  // Add new top-level thread
  const handleNewThread = (newThread) => {
    setThreads((prev) => [...prev, newThread]);
  };

  // Add new reply as a thread with parentId
  const handleNewReply = (threadId, newReply) => {
    setThreads((prev) => [...prev, newReply]);
  };

  const handleTrackSelection = (track) => {
    setSelectedTrack(track);
    setShowThread(true);
    setCurrentPage("Hero");
  };

  const handleNewUsername = (username) => {
    setUsername(username);
    if (username) setIsLoggedIn(true);
  };

  return (
    <div className="App">
      <NavBar
        onTrackSelect={handleTrackSelection}
        setCurrentPage={setCurrentPage}
        setUsername={handleNewUsername}
        username={username}
        usernamePopup={usernamePopup}
        setUsernamePopup={setUsernamePopup}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
      />

      {currentPage === "Home" && <Home onTrackSelect={handleTrackSelection} />}

      {currentPage === "Hero" && selectedTrack && (
        <Hero
          onNewThread={handleNewThread}
          selectedTrack={selectedTrack}
          username={username}
          isLoggedIn={isLoggedIn}
          setUsernamePopup={setUsernamePopup}
        />
      )}

      {currentPage === "Hero" && showThread && !loading && !error && (
        <Thread
          threads={threads}
          onNewReply={handleNewReply}
          username={username}
          setUsernamePopup={setUsernamePopup}
        />
      )}

      {loading && <p>Loading threads...</p>}
      {error && <p>{error}</p>}
    </div>
  );
}

export default App;
